import { render } from "./BrandPage.vue?vue&type=template&id=406cbd26&scoped=true"
import script from "./BrandPage.vue?vue&type=script&lang=js"
export * from "./BrandPage.vue?vue&type=script&lang=js"

import "./BrandPage.vue?vue&type=style&index=0&id=406cbd26&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-406cbd26"]])

export default __exports__